import React, { useMemo, useState } from 'react'
import LayoutForm from '../../../containers/layouts/LayoutForm'
import { Alert, Card, CardBody } from 'react-bootstrap'
import { Header } from '../../../components/Containers/Header'
import { Lista, Option, ModalAllergicSymptomp } from './components'
import { activarModalGenerico, clearActiveAllergicSymptom } from '../../../store/slices/uiSlice'
import { useDispatch } from 'react-redux'
import { ACTIONS, modules, PERMISSIONS } from '../../../constants'
import { toastAdapter } from '../../../plugins'
import {
  useAddAllergicSymptomMutation,
  useUpdateAllergicSymptomMutation
} from '../../../services/rtk-query'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { genericFormSchema } from '../../../utils'
import { usePermissions } from '../../../hooks'

export const SintomasAlergiasPage = () => {
  const { hasPermission } = usePermissions()
  const dispatch = useDispatch()
  const [action, setAction] = useState(ACTIONS.SAVE)
  const [addAllergicSymptom] = useAddAllergicSymptomMutation()
  const [updateMenstruacion] = useUpdateAllergicSymptomMutation()
  const {
    handleSubmit,
    formState: { errors },
    control,
    reset,
    setValue,
    getValues
  } = useForm({
    resolver: yupResolver(genericFormSchema),
    defaultValues: {
      nombre: '',

      id: 0
    }
  })
  const columns = useMemo(
    () => [
      {
        header: 'id',
        accessorKey: 'id'
      },
      {
        header: 'nombre',
        accessorKey: 'nombre'
      },
      {
        header: 'Activo',
        accessorKey: 'activo',
        cell: ({ row: { original } }) =>
          original.activo ? (
            <Alert
              variant="primary"
              className="text-center d-flex justify-content-center align-items-center"
              style={{
                width: '5rem',
                height: '2rem'
              }}
            >
              Si
            </Alert>
          ) : (
            <Alert
              variant="danger"
              className="text-center d-flex justify-content-center align-items-center"
              style={{
                width: '5rem',
                height: '2rem'
              }}
            >
              No
            </Alert>
          )
      },
      {
        header: 'Opciones',
        accessorKey: 'id',
        cell: ({ row: { original } }) => (
          <Option
            cell={original.id}
            setAction={setAction}
            activo={original.activo}
            hasPermission={!hasPermission([PERMISSIONS.WRITE], modules.sintomas)}
          />
        )
      }
    ],
    []
  )
  const handler = () => {
    dispatch(activarModalGenerico())
  }

  const handlerAction = (data) => {
    if (action === ACTIONS.SAVE) return handleSave(data)

    return handleUpdate(data)
  }

  const handleSave = (data) => {
    const { id, ...rest } = data
    toastAdapter.promise({
      promise: addAllergicSymptom(rest).unwrap(),
      successMessage: () => {
        reset()
        setAction(ACTIONS.SAVE)

        return 'Sintomas de Alergias guardado con éxito'
      },
      errorMessage: 'Error al guardar la Sintomas de Alergias',
      loadingMessage: 'Guardando Sintomas de Alergias...'
    })
  }

  const handleUpdate = (data) => {
    toastAdapter.promise({
      promise: updateMenstruacion({ ...data, id: +getValues('id') }).unwrap(),
      successMessage: () => {
        reset()
        setAction(ACTIONS.SAVE)
        dispatch(clearActiveAllergicSymptom())
        return 'Sintomas de Alergias guardado con éxito'
      },
      errorMessage: 'Error al guardar la Sintomas de Alergias',
      loadingMessage: 'Guardando Sintomas de Alergias...'
    })
  }
  const handleReset = () => {
    reset()
    setAction(ACTIONS.SAVE)
    dispatch(clearActiveAllergicSymptom())
  }

  return (
    <LayoutForm title="Sintomas de Alergias">
      <Card className="shadow-none">
        <Header
          title="Sintomas"
          subtitle="Sintomas de Alergias"
          buttonTitle="Nueva Sintomas de Alergias"
          handler={handler}
          hasPermission={!hasPermission([PERMISSIONS.WRITE], modules.sintomas)}
        />
        <CardBody>
          <Lista columns={columns} />
        </CardBody>
      </Card>
      <ModalAllergicSymptomp
        Menstruales
        action={action}
        control={control}
        errors={errors}
        handlerAction={handlerAction}
        handleSubmit={handleSubmit}
        reset={handleReset}
        setValue={setValue}
      />
    </LayoutForm>
  )
}
